import { useEffect, useState, useCallback } from 'react';

import { getStatus } from '@klv/organisms/klaviyo-status-indicator/utils/functions';

import StaticKlaviyoStatusIndicator from './static-component';

import type { IKlaviyoStatusIndicator } from './types';


const KlaviyoStatusIndicator = ({ ...props }: IKlaviyoStatusIndicator) => {
  const [status, setStatus] = useState<IKlaviyoStatusIndicator | null>(null);

  const fetchStatus = useCallback(async (abortController: AbortController) => {
    const statusResponse = await getStatus();
    if (!abortController.signal.aborted) {
      setStatus({
        indicator: (statusResponse?.status?.indicator as IKlaviyoStatusIndicator['indicator']) ?? null,
        status: (statusResponse?.status?.description as IKlaviyoStatusIndicator['status']) ?? null,
      });
    }
  }, []);

  useEffect(() => {
    const fetchAbortController = new AbortController();

    fetchStatus(fetchAbortController);

    const intervalId = window.setInterval(() => {
      fetchStatus(fetchAbortController);
    }, 60000);

    return () => {
      fetchAbortController.abort();
      window.clearInterval(intervalId);
    };
  }, [fetchStatus]);

  return (<StaticKlaviyoStatusIndicator {...status} {...props} />);
};

export default KlaviyoStatusIndicator;
